<template lang="pug">
  v-card
    v-card-text
      div(v-if="reverse" style="position:relative;line-height:0px;display:inline;float:left;margin:0px 15px 8px 0px;padding:0px;height:auto;width:290px;")
        img(:src="imagen" width="290px")
        v-btn(style="position:absolute;bottom:3px;right:3px;padding:4px 7px 4px 7px;height:auto;" small color="primary").txtn Descargar
      div.customImage(v-else style="position:relative;line-height:0px;display:inline;float:right;margin:0px 0px 8px 15px;padding:0px;height:auto;width:290px;")
        img(:src="imagen" width="290px")
        v-btn(style="position:absolute;bottom:3px;right:3px;padding:4px 7px 4px 7px;height:auto;" small color="primary").txtn Descargar
      div(style="width:auto;")
        h6.subtitle-1.primary--text(style="text-align:justify;line-height:22px").mb-2 {{ titulo }}
      //-div(style="width:auto;")
        h6.subtitle-2.error--text(style="text-align:justify;line-height:22px").mb-1 {{ fecha }}
      p(style="text-align:justify;border-top:solid 3px #4A90E2").pt-3.mb-0
        span.subtitle-2.error--text {{ fecha }} &nbsp;
        | {{ description }}
</template>

<script>
export default {
  data: () => ({
    rotator: 0
  }),
  props: {
    reverse: Boolean,
    imagen: String,
    titulo: String,
    fecha: String,
    description: String,
  }
}
</script>
